import React from 'react';
import { useTranslation } from 'react-i18next';
import ClaimFormModal from 'pages/MyOrdersPage/OrderClaims/ClaimFormModal';
import ClaimsFilter from 'pages/MyOrdersPage/OrderClaims/Filter/ClaimsFilter';
import InitiateClaimButton from 'pages/MyOrdersPage/OrderClaims/InitiateClaimButton';
import { Flex, Text } from 'UI';
import ClaimsTable from './ClaimsTable';

const OrderClaims = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [tableWidth, setTableWidth] = React.useState(0);
  const { t } = useTranslation();

  return (
    <Flex direction={'column'} align={'center'} gap={30}>
      <ClaimFormModal isOpen={isOpen} setIsOpen={setIsOpen} />
      <Flex justify={'space-between'} minWidth={tableWidth || '100%'}>
        <Text type="heading3">{t('order.order_detail.claims', 'Claims')}</Text>
        <InitiateClaimButton setIsOpen={setIsOpen} />
      </Flex>
      <Flex direction={'column'} gap={30}>
        <ClaimsFilter />
        <ClaimsTable setTableWidth={setTableWidth} />
      </Flex>
    </Flex>
  );
};

export default OrderClaims;
